import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import Dialog from 'ui/views/dialogs/Dialog';
import CloseIcon from 'ui/elements/icons/CloseIcon';
import DownloadIcon from 'ui/elements/icons/DownloadIcon';
import { contentSpacing, sectionSpacing } from 'ui/theme/themeConstants';
import { bluePlanetTheme } from 'ui/theme';
import IconButton from 'ui/elements/icons/IconButton';

interface ImageLightboxProps {
  imageUrl: string;
  filename: string;
  onClose: () => void;
  onDownload: () => Promise<void>;
}

const LightboxBackdrop = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${bluePlanetTheme.bluePlanetPalette.black};
  width: 100%;
  height: calc(100vh - ${sectionSpacing});
  cursor: pointer;
  padding: ${contentSpacing};
  position: relative;
`;

const LightboxImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  cursor: default;
`;

export default function ImageLightbox(props: ImageLightboxProps) {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') props.onClose();
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [props.onClose]);

  return (
    <Dialog
      open={true}
      onClose={props.onClose}
      fullScreen
      backgroundColor="transparent"
      paperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      }}
    >
      <LightboxBackdrop onClick={props.onClose}>
        <LightboxImage
          src={props.imageUrl}
          alt={props.filename}
          onClick={e => e.stopPropagation()} // Prevent close on image click
        />
        <div style={{ position: 'absolute', top: contentSpacing, right: contentSpacing }}>
          <IconButton
            color="white"
            hoverColor="grey"
            onClick={e => {
              e.stopPropagation(); // Prevent dialog from closing
              props.onDownload();
            }}
            size="large"
            title="Download"
          >
            <DownloadIcon />
          </IconButton>
          <IconButton color="white" hoverColor="grey" onClick={props.onClose} size="large" title="Close">
            <CloseIcon />
          </IconButton>
        </div>
      </LightboxBackdrop>
    </Dialog>
  );
}
